/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Inspections Icon component.
 */
export const SideNavInspectionsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_16019_9416)'>
        <path d='M17.25 -1.49902C17.6642 -1.49902 18 -1.16324 18 -0.749023V2.25098H20L20.2041 2.26172C21.2128 2.36398 22 3.21533 22 4.25098V21.251C22 22.2866 21.2128 23.138 20.2041 23.2402L20 23.251H5C3.96435 23.251 3.113 22.4638 3.01074 21.4551L3 21.251V4.25098C3 3.14641 3.89543 2.25098 5 2.25098H7.5V-0.749023C7.5 -1.16324 7.83579 -1.49902 8.25 -1.49902C8.66421 -1.49902 9 -1.16324 9 -0.749023V2.25098H16.5V-0.749023C16.5 -1.16324 16.8358 -1.49902 17.25 -1.49902ZM5 3.75098C4.72386 3.75098 4.5 3.97483 4.5 4.25098V21.251C4.5 21.5271 4.72386 21.751 5 21.751H20C20.2761 21.751 20.5 21.5271 20.5 21.251V4.25098C20.5 3.97483 20.2761 3.75098 20 3.75098H5ZM11.5 17.751H7V16.251H11.5V17.751ZM18.5869 11.9277L15.1982 15.3164L13.4111 13.5293L13.6074 13.335L13.9619 12.9824L14.1562 12.7891L15.1982 13.8311L17.6514 11.3809L17.8457 11.1865L18.5869 11.9277ZM11.5 13.751H7V12.251H11.5V13.751ZM18.5869 6.92773L15.1982 10.3164L13.4111 8.5293L13.6074 8.33496L13.9619 7.98242L14.1562 7.78906L15.1982 8.83105L17.6514 6.38086L17.8457 6.18652L18.5869 6.92773ZM11.5 9.75098H7V8.25098H11.5V9.75098Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_16019_9416'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavInspectionsIcon;
